




















import { Component, Vue, Prop, Emit } from "vue-property-decorator";

@Component
export default class AppSearchBar extends Vue {
  search: string = "";
  async onCreateEvent() {
    this.$router.push("/braze-webhooks/new");
  }

  @Emit("onSearch")
  async onSearch() {
    return this.search;
  }
}
